import styled, {css} from 'styled-components';

import breakpoints from '~constants/breakpoints';

import {TextSmall} from '../Text';

type ButtonProps = {
    color: 'white' | 'black';
    isActive?: boolean;
};

export const StyledButton = styled.button<ButtonProps>`
    flex: 1;
    background: none;
    border: none;
    border-radius: 12px;
    outline: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: ${({color}) => color};

    ${breakpoints.abovePhone} {
        svg {
            margin-right: 5.5px;
        }
    }

    ${({isActive, color}) =>
        isActive &&
        (color === 'black'
            ? css`
                  background: #ffffff;
                  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.08);
              `
            : css`
                  background: rgba(255, 255, 255, 0.1);
                  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
              `)}
`;

export const Label = styled(TextSmall)`
    display: none;

    ${breakpoints.abovePhone} {
        display: block;
    }
`;
